import { useStatsOverview } from './useStatsOverview'
import type { StatsOverview } from './types'

export type { TicketStats } from './types'

export function useTicketStats() {
  const q = useStatsOverview()
  return { ...q, data: q.data?.tickets as StatsOverview['tickets'] | undefined }
}
